import React from 'react';
import { Button } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/pro-light-svg-icons';
import PropTypes from 'prop-types';
import { Box, Text } from '../../../shared/components';
import TwoColumnsFlexLayout from '../../../shared/components/layout/TwoColumnsFlex.layout';

const GiotalkHeader = ({
  onBackButtonPressed, title, subtitle, rightContent,
}) => (
  <Box style={{ borderBottom: '1px solid #1d586f' }} pb="16">
    <TwoColumnsFlexLayout
      flexLeft={3}
      flexRight={1}
      leftContent={(
        <Box>
          <Box>
            <Button
              onClick={() => onBackButtonPressed()}
              style={{ padding: 0 }}
              type="link"
              ghost
            >
              <FontAwesomeIcon style={{ marginBottom: '3px' }} icon={faArrowLeft} color="lightgrey" />
            </Button>
            <Text
              ml="8"
              fontSize="24"
              color="white"
              style={{
                maxWidth: '90%',
                textOverflow: 'ellipsis',
                wordWrap: 'break-word',
                whiteSpace: 'nowrap',
                overflow: 'hidden'
              }}
            >
              {title}
            </Text>
          </Box>
        </Box>
        )}
      rightContent={rightContent}
    />
    <Box mt={"8"}>
      {subtitle}
    </Box>
  </Box>
);

export default GiotalkHeader;

GiotalkHeader.propTypes = {
  onBackButtonPressed: PropTypes.func.isRequired,
  rightContent: PropTypes.element,
  subtitle: PropTypes.element,
  title: PropTypes.element.isRequired,
};
